import React from "react";

const LeftSideDoor = () => {
    return (
        <svg width="82" height="93" viewBox="0 0 82 93" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M5.58964 92.2246H0L0 0.374611H5.58964L5.58964 92.2246Z" fill="#4A5353" />
            <path d="M81.4219 92.3008C81.4219 41.4919 45.1558 0.300781 0.421874 0.300781" stroke="#4A5353" stroke-width="0.6" stroke-miterlimit="10" />
        </svg>
    )
}
export default LeftSideDoor;